import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { getCurrentUserIsTrueSystemUser } from '../state/authentication.selector';

@Injectable({
   providedIn: 'root',
})
export class SystemUserGuard  {
   constructor(private store: Store, private router: Router, private location: Location) {}

   canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
      return this.isSystemUser(state);
   }

   private isSystemUser(state: RouterStateSnapshot): Observable<boolean> {
      return this.store.pipe(
         select(getCurrentUserIsTrueSystemUser),
         first(),
         map((isSystemUser) => {
            if (!isSystemUser) {
               this.router.navigate(['access-denied'], { skipLocationChange: true }).then(() => {
                  // this is required because skipLocationChange doesn't do what it's supposed to
                  // see https://github.com/angular/angular/issues/16981
                  // and https://github.com/angular/angular/issues/17004
                  // this causes the URL to flicker upon first navigation but it's
                  // better than setting the url to '/access-denied'
                  this.location.replaceState(state.url);
               });
               return false;
            }
            return true;
         })
      );
   }
}
